// EOIR nationality codes — exact copy from acis.eoir.justice.gov dropdown
// These codes MUST match exactly what EOIR has on file
// Shared between Dashboard.js and ProfessionalDashboard.js
export const NATIONALITY_OPTIONS = [
  { code: 'AF', label: 'Afghanistan' },
  { code: 'AL', label: 'Albania' },
  { code: 'AG', label: 'Algeria' },
  { code: 'AN', label: 'Andorra' },
  { code: 'AO', label: 'Angola' },
  { code: 'AV', label: 'Anguilla' },
  { code: 'AC', label: 'Antigua and Barbuda' },
  { code: 'AR', label: 'Argentina' },
  { code: 'AM', label: 'Armenia' },
  { code: 'AB', label: 'Aruba' },
  { code: 'AS', label: 'Australia' },
  { code: 'AU', label: 'Austria' },
  { code: 'AZ', label: 'Azerbaijan' },
  { code: 'BF', label: 'Bahamas' },
  { code: 'BA', label: 'Bahrain' },
  { code: 'BG', label: 'Bangladesh' },
  { code: 'BB', label: 'Barbados' },
  { code: 'XX', label: 'Be Removed From The United States' },
  { code: 'BZ', label: 'Belarus' },
  { code: 'BE', label: 'Belgium' },
  { code: 'BH', label: 'Belize' },
  { code: 'BN', label: 'Benin' },
  { code: 'BD', label: 'Bermuda' },
  { code: 'BT', label: 'Bhutan' },
  { code: 'BL', label: 'Bolivia' },
  { code: 'BI', label: 'Bosnia-Herzegovina' },
  { code: 'BC', label: 'Botswana' },
  { code: 'BV', label: 'Bouvet Island' },
  { code: 'BR', label: 'Brazil' },
  { code: 'IO', label: 'British Indian Ocean Territory' },
  { code: 'VI', label: 'British Virgin Islands' },
  { code: 'BW', label: 'British West Indies' },
  { code: 'BX', label: 'Brunei' },
  { code: 'BU', label: 'Bulgaria' },
  { code: 'BO', label: 'Burkina Faso' },
  { code: 'BM', label: 'Burma (Myanmar)' },
  { code: 'BY', label: 'Burundi' },
  { code: 'BS', label: 'Byelorussia (Belarus)' },
  { code: 'CC', label: 'Cambodia' },
  { code: 'CM', label: 'Cameroon' },
  { code: 'CA', label: 'Canada' },
  { code: 'CV', label: 'Cape Verde' },
  { code: 'CJ', label: 'Cayman Islands' },
  { code: 'CT', label: 'Central African Republic' },
  { code: 'CD', label: 'Chad' },
  { code: 'CI', label: 'Chile' },
  { code: 'CH', label: 'China' },
  { code: 'KT', label: 'Christmas Islands' },
  { code: 'CK', label: 'Cocos Island' },
  { code: 'CO', label: 'Colombia' },
  { code: 'CN', label: 'Comoro Islands' },
  { code: 'CF', label: 'Congo' },
  { code: 'CW', label: 'Cook Islands' },
  { code: 'CS', label: 'Costa Rica' },
  { code: 'CX', label: 'Croatia' },
  { code: 'CU', label: 'Cuba' },
  { code: 'CY', label: 'Cyprus' },
  { code: 'CR', label: 'Czech Republic' },
  { code: 'DC', label: 'Democratic Republic of Congo' },
  { code: 'DA', label: 'Denmark' },
  { code: 'DJ', label: 'Djibouti' },
  { code: 'DO', label: 'Dominica' },
  { code: 'DR', label: 'Dominican Republic' },
  { code: 'TM', label: 'East Timor' },
  { code: 'EC', label: 'Ecuador' },
  { code: 'EG', label: 'Egypt' },
  { code: 'ES', label: 'El Salvador' },
  { code: 'EK', label: 'Equatorial Guinea' },
  { code: 'ER', label: 'Eritrea' },
  { code: 'EO', label: 'Estonia' },
  { code: 'ET', label: 'Ethiopia' },
  { code: 'FO', label: 'Faeroe Island' },
  { code: 'FA', label: 'Falkland Islands' },
  { code: 'FM', label: 'Federated States of Micronesia' },
  { code: 'FJ', label: 'Fiji' },
  { code: 'FI', label: 'Finland' },
  { code: 'CZ', label: 'Former Countries (CZ)' },
  { code: 'GC', label: 'Former Countries (GC)' },
  { code: 'UR', label: 'Former Countries (UR)' },
  { code: 'YO', label: 'Former Countries (YO)' },
  { code: 'YS', label: 'Former Countries (YS)' },
  { code: 'FR', label: 'France' },
  { code: 'FG', label: 'French Guiana' },
  { code: 'FP', label: 'French Polynesia' },
  { code: 'FS', label: 'French Southern and Antarctic Lands' },
  { code: 'FW', label: 'French West Indies' },
  { code: 'GB', label: 'Gabon' },
  { code: 'GA', label: 'Gambia' },
  { code: 'GZ', label: 'Gaza Strip' },
  { code: 'GO', label: 'Georgia' },
  { code: 'GE', label: 'Germany' },
  { code: 'GH', label: 'Ghana' },
  { code: 'GI', label: 'Gibraltar' },
  { code: 'GR', label: 'Greece' },
  { code: 'GL', label: 'Greenland' },
  { code: 'GJ', label: 'Grenada' },
  { code: 'GP', label: 'Guadeloupe' },
  { code: 'GT', label: 'Guatemala' },
  { code: 'GV', label: 'Guinea' },
  { code: 'PU', label: 'Guinea Bissau' },
  { code: 'GY', label: 'Guyana' },
  { code: 'HA', label: 'Haiti' },
  { code: 'HM', label: 'Heard and McDonald Islands' },
  { code: 'HL', label: 'Holland' },
  { code: 'HO', label: 'Honduras' },
  { code: 'HK', label: 'Hong Kong' },
  { code: 'HU', label: 'Hungary' },
  { code: 'IC', label: 'Iceland' },
  { code: 'IU', label: 'In Absentia/Unknown' },
  { code: 'IN', label: 'India' },
  { code: 'ID', label: 'Indonesia' },
  { code: 'IR', label: 'Iran' },
  { code: 'IZ', label: 'Iraq' },
  { code: 'EI', label: 'Ireland' },
  { code: 'IS', label: 'Israel' },
  { code: 'IT', label: 'Italy' },
  { code: 'IV', label: "Ivory Coast (Cote D'Ivoire)" },
  { code: 'JM', label: 'Jamaica' },
  { code: 'JA', label: 'Japan' },
  { code: 'JO', label: 'Jordan' },
  { code: 'CB', label: 'Kampuchea' },
  { code: 'KZ', label: 'Kazakhstan' },
  { code: 'KE', label: 'Kenya' },
  { code: 'KG', label: 'Kirghizia (Kyrgyzstan)' },
  { code: 'KR', label: 'Kiribati' },
  { code: 'KV', label: 'Kosovo' },
  { code: 'KU', label: 'Kuwait' },
  { code: 'LA', label: 'Laos' },
  { code: 'LV', label: 'Latvia' },
  { code: 'LE', label: 'Lebanon' },
  { code: 'LT', label: 'Lesotho' },
  { code: 'LI', label: 'Liberia' },
  { code: 'LY', label: 'Libya' },
  { code: 'LS', label: 'Liechtenstein' },
  { code: 'LH', label: 'Lithuania' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'MC', label: 'Macau' },
  { code: 'MM', label: 'Macedonia' },
  { code: 'MA', label: 'Madagascar' },
  { code: 'MI', label: 'Malawi' },
  { code: 'MY', label: 'Malaysia' },
  { code: 'MV', label: 'Maldives' },
  { code: 'ML', label: 'Mali' },
  { code: 'MT', label: 'Malta' },
  { code: 'MB', label: 'Martinique' },
  { code: 'MR', label: 'Mauritania' },
  { code: 'MP', label: 'Mauritius' },
  { code: 'MX', label: 'Mexico' },
  { code: 'MQ', label: 'Midway Islands' },
  { code: 'MD', label: 'Moldavia (Moldova)' },
  { code: 'MN', label: 'Monaco' },
  { code: 'MG', label: 'Mongolia' },
  { code: 'MJ', label: 'Montenegro' },
  { code: 'MH', label: 'Montserrat' },
  { code: 'MO', label: 'Morocco' },
  { code: 'MZ', label: 'Mozambique' },
  { code: 'WA', label: 'Namibia' },
  { code: 'NR', label: 'Nauru' },
  { code: 'NP', label: 'Nepal' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'NA', label: 'Netherlands Antilles' },
  { code: 'NC', label: 'New Caledonia' },
  { code: 'NZ', label: 'New Zealand' },
  { code: 'NU', label: 'Nicaragua' },
  { code: 'NG', label: 'Niger' },
  { code: 'NI', label: 'Nigeria' },
  { code: 'NE', label: 'Niue' },
  { code: 'NN', label: 'No Nationality' },
  { code: 'NF', label: 'Norfolk Island' },
  { code: 'KN', label: 'North Korea' },
  { code: 'NO', label: 'Norway' },
  { code: 'MU', label: 'Oman' },
  { code: 'PK', label: 'Pakistan' },
  { code: 'PN', label: 'Palestine' },
  { code: 'PM', label: 'Panama' },
  { code: 'PP', label: 'Papua New Guinea' },
  { code: 'PA', label: 'Paraguay' },
  { code: 'DM', label: "People's Republic of Benin" },
  { code: 'PE', label: 'Peru' },
  { code: 'RP', label: 'Philippines' },
  { code: 'PC', label: 'Pitcairn Islands' },
  { code: 'PL', label: 'Poland' },
  { code: 'PO', label: 'Portugal' },
  { code: 'QA', label: 'Qatar' },
  { code: 'RE', label: 'Reunioun' },
  { code: 'RO', label: 'Romania' },
  { code: 'RU', label: 'Russia' },
  { code: 'RW', label: 'Rwanda' },
  { code: 'WS', label: 'Samoa' },
  { code: 'SM', label: 'San Marino' },
  { code: 'TP', label: 'Sao Tome and Principe' },
  { code: 'SA', label: 'Saudi Arabia' },
  { code: 'SG', label: 'Senegal' },
  { code: 'RS', label: 'Serbia' },
  { code: 'SE', label: 'Seychelles' },
  { code: 'SL', label: 'Sierra Leone' },
  { code: 'SN', label: 'Singapore' },
  { code: 'SR', label: 'Slovak Republic' },
  { code: 'SV', label: 'Slovenia' },
  { code: 'BP', label: 'Solomon Islands' },
  { code: 'SO', label: 'Somalia' },
  { code: 'SF', label: 'South Africa' },
  { code: 'KS', label: 'South Korea' },
  { code: 'XS', label: 'South Sudan' },
  { code: 'SP', label: 'Spain' },
  { code: 'CE', label: 'Sri Lanka' },
  { code: 'SC', label: 'St. Christopher-Nevis' },
  { code: 'SH', label: 'St. Helena' },
  { code: 'SK', label: 'St. Kitts, West Indies' },
  { code: 'ST', label: 'St. Lucia' },
  { code: 'SB', label: 'St. Pierre and Miquelon' },
  { code: 'VC', label: 'St. Vincent and the Grenadines' },
  { code: 'SS', label: 'Stateless - Alien Unable to Name a Country' },
  { code: 'SU', label: 'Sudan' },
  { code: 'NS', label: 'Suriname' },
  { code: 'WZ', label: 'Swaziland' },
  { code: 'SW', label: 'Sweden' },
  { code: 'SZ', label: 'Switzerland' },
  { code: 'SY', label: 'Syria' },
  { code: 'TW', label: 'Taiwan' },
  { code: 'TA', label: 'Tajikistan (Tadzhik)' },
  { code: 'TZ', label: 'Tanzania' },
  { code: 'TH', label: 'Thailand' },
  { code: 'PS', label: 'The Republic of Palau' },
  { code: 'RM', label: 'The Republic of the Marshall Islands' },
  { code: 'TO', label: 'Togo' },
  { code: 'TL', label: 'Tokelau' },
  { code: 'TN', label: 'Tonga' },
  { code: 'TD', label: 'Trinidad and Tobago' },
  { code: 'TS', label: 'Tunisia' },
  { code: 'TU', label: 'Turkiye' },
  { code: 'TR', label: 'Turkmenistan' },
  { code: 'TK', label: 'Turks and Caicos Islands' },
  { code: 'TV', label: 'Tuvalu' },
  { code: 'UG', label: 'Uganda' },
  { code: 'UE', label: 'Ukraine' },
  { code: 'TC', label: 'United Arab Emirates' },
  { code: 'UK', label: 'United Kingdom' },
  { code: 'UN', label: 'Unknown Nationality' },
  { code: 'UV', label: 'Upper Volta' },
  { code: 'UY', label: 'Uruguay' },
  { code: 'UZ', label: 'Uzbekistan' },
  { code: 'NH', label: 'Vanuatu' },
  { code: 'VE', label: 'Venezuela' },
  { code: 'VM', label: 'Vietnam' },
  { code: 'WI', label: 'Western Sahara' },
  { code: 'YE', label: 'Yemen' },
  { code: 'CG', label: 'Zaire' },
  { code: 'ZA', label: 'Zambia' },
  { code: 'ZI', label: 'Zimbabwe' },
];
